import TableDateCell from '../../../../shared/components/table-cells/TableDateCell/TableDateCell';
import { Alignments } from '../../../../shared/components/ui/Table/enums/alignments.enum';
import { TableColumnDef } from '../../../../shared/components/ui/Table/models/table-column.model';
import { castTo } from '../../../../shared/utils/cast-to';
import { stringToPascalCase } from '../../../../shared/utils/string-to-pascal-case/string-to-pascal-case.util';
import { AppTableModel } from '../../../models/app-table.model';
import PlatformsTableCell from '../../PlatformsTableCell/PlatformsTableCell';
import TableAppsNameCell from '../../TableAppsNameCell/TableAppsNameCell';

export const getAppsColumns = (imageLoaded: () => void): TableColumnDef[] => {
  return [
    {
      field: 'name',
      headerName: 'Name',
      sortable: true,
      alignment: Alignments.LEFT,
      width: '524px',
      valueGetter: row => {
        return (
          <TableAppsNameCell
            imageLoadFn={imageLoaded}
            row={row as unknown as AppTableModel}
          ></TableAppsNameCell>
        );
      },
    },
    {
      field: 'categories',
      headerName: 'Category',
      alignment: Alignments.LEFT,
      width: '148px',
      sortable: false,
    },
    {
      field: 'platform',
      headerName: 'Platform',
      alignment: Alignments.LEFT,
      width: '146px',
      sortable: false,
      valueGetter: row => {
        const currentRow = castTo<AppTableModel>(row);

        if (currentRow.formattedPlatforms) {
          return PlatformsTableCell(currentRow.formattedPlatforms);
        }

        return currentRow.platform;
      },
    },
    {
      field: 'lastUpdated',
      headerName: 'Last updated',
      alignment: Alignments.LEFT,
      width: '173px',
      sortable: false,
      valueGetter: row => {
        return (
          <TableDateCell
            date={castTo<AppTableModel>(row).lastUpdated}
          ></TableDateCell>
        );
      },
    },
    {
      field: 'status',
      headerName: 'Status',
      alignment: Alignments.RIGHT,
      width: '95px',
      sortable: false,
      valueGetter: row =>
        row.status ? stringToPascalCase(castTo<string>(row.status)) : '',
    },
  ];
};
